import InputDateUTC from '../../../../../../components/FormControl/input/InputDateUTC';
import { updateSurveyToFillQuestion } from '../../../../../../store/actions/dataEntryFillASurveyActions';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './SurveyDateQuestion.css';

const SurveyDateQuestion = ({ question, disabled, onChangeAlert }) => {
  const dispatch = useDispatch();
  const { id, config, answer, error } = question;
  const [value, setValue] = useState(answer && answer.length ? answer[0] : null);

  const onChangeInputValue = (newValue) => {
    const dateValue = isValidDate(new Date(newValue)) ? newValue : null;
    dispatch(
      updateSurveyToFillQuestion({
        questionId: id,
        newData: { answer: dateValue ? [dateValue] : [], error: null }
      })
    );

    onChangeAlert();
  };

  const isValidDate = (date = null) => {
    return date && !isNaN(date.getTime());
  };

  useEffect(() => {
    setValue(answer && answer.length ? answer[0] : null);
  }, [answer]);

  return (
    <>
      <div style={{ width: '140px' }}>
        <InputDateUTC
          clearable={true}
          className='custom-text-field'
          id={`date-answer-${id}`}
          variant='standard'
          autoOk={true}
          name='value'
          value={value ?? null}
          placeholder={config?.placeholder || 'DD/MMM/YYYY'}
          label='Add Date'
          onChange={(value) => onChangeInputValue(value)}
          disabled={disabled}
        />
      </div>
      {error && <p className='survey-question__error-hint'>{error}</p>}
    </>
  );
};

export default SurveyDateQuestion;
